// Module
var code = "<div class=\"empty-list\">\n    <div class=\"empty-list-header\" ng-i18next=\"[html](i18nData){{header}}\"></div>\n    <div class=\"empty-list-body\" ng-i18next=\"[html](i18nData){{body}}\"></div>\n</div>\n";
// Exports
module.exports = code;